import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

type MovieCardProps = {
  movie: Movie;
  showRank?: number;
};

export default function MovieCard({ movie, showRank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block w-full cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200 border border-background-300/60">
        <img
          src={movie.cover}
          alt={`${movie.title} 影片封面`}
          title={`${movie.title} - 日韩黄色电影`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-80" />

        <div className="absolute top-2.5 left-2.5 flex items-center gap-1.5">
          <span className="px-2 py-1 rounded-md bg-background-50/80 backdrop-blur-sm text-[10px] tracking-wider text-foreground-800">
            {movie.region}
          </span>
          {showRank && (
            <span className="px-2 py-1 rounded-md bg-primary-500 text-[10px] font-label tracking-wider text-foreground-950">
              NO.{showRank}
            </span>
          )}
        </div>

        <div className="absolute top-2.5 right-2.5 px-2 py-1 rounded-md bg-background-50/80 backdrop-blur-sm flex items-center gap-1">
          <i className="ri-star-fill text-[10px] text-accent-500" />
          <span className="text-[10px] text-foreground-800">{movie.rating.toFixed(1)}</span>
        </div>

        <div className="absolute inset-x-0 bottom-0 p-3 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          <span className="inline-flex items-center gap-1.5 text-xs text-accent-500">
            查看详情
            <i className="ri-arrow-right-line" />
          </span>
        </div>
      </div>

      <div className="pt-3">
        <h3 className="text-sm md:text-[15px] text-foreground-900 group-hover:text-accent-500 transition-colors truncate">
          {movie.title}
        </h3>
        <p className="mt-1 text-[11px] text-foreground-500 truncate">
          {movie.year} · {movie.lengthType} · {movie.duration} 分钟
        </p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="px-1.5 py-0.5 rounded text-[10px] bg-background-200/80 text-foreground-600 border border-background-300/60"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}